var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1895 2H7.80951C4.16951 2 1.99951 4.17 1.99951 7.81V16.18C1.99951 19.83 4.16951 22 7.80951 22H16.1795C19.8195 22 21.9895 19.83 21.9895 16.19V7.81C21.9995 4.17 19.8295 2 16.1895 2ZM15.9995 12.75H12.7495V16C12.7495 16.41 12.4095 16.75 11.9995 16.75C11.5895 16.75 11.2495 16.41 11.2495 16V12.75H7.99951C7.58951 12.75 7.24951 12.41 7.24951 12C7.24951 11.59 7.58951 11.25 7.99951 11.25H11.2495V8C11.2495 7.59 11.5895 7.25 11.9995 7.25C12.4095 7.25 12.7495 7.59 12.7495 8V11.25H15.9995C16.4095 11.25 16.7495 11.59 16.7495 12C16.7495 12.41 16.4095 12.75 15.9995 12.75Z",
    fill: "#75758A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.4ea514fc537c2f7b8d8695706561c078.svg";
export { ForwardRef as ReactComponent };